<svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10">
  <path d="M20 0H0V2H20V0Z" />
  <path d="M20 8H4V10H20V8Z" />
</svg>
